for (const el of document.getElementsByClassName('category-view')) {
    el.addEventListener('click', () => {
        naja.makeRequest('POST', el.dataset.link, {
                type: el.dataset.categoryView
            }, {
                history: false
            }
        ).then(_ => {
            document.getElementById('category-view-list').classList.remove('active');
            document.getElementById('category-view-grid').classList.remove('active');
            document.getElementById('category-view-compact').classList.remove('active');
            el.classList.add('active');
        })
    })
}

document.querySelectorAll(".sub-menu.show").forEach(el => el.parentNode.classList.add("active"));
